<template>
  <div class="layer_section-container">
    <div class="layer-header">
      <h1 class="header-title">재주문 신청</h1>
      <button type="button" class="btn-modal_close" @click="onDispose">
        닫기
      </button>
    </div>
    <div class="layer-content total_order_cancel">
      <div class="layer_cont_wrap">
        <div class="layer_cont">
          <div class="layer_cont_box">
            <div class="info_list_box bg_gray">
              <dl>
                <dt>마이팩 명</dt>
                <dd>{{ mypackName }}</dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="layer_cont">
          <h2 class="layer_cont_title_s">
            이전 마이팩과 동일한 상담내용(제품, 섭취인, 건강상태 등)으로 제품을
            구매하시겠습니까?
          </h2>
          <div class="layer_cont_box">
            <div class="choice-abc">
              <div class="form_group-element">
                <span class="form_element-checkbox">
                  <input
                    type="checkbox"
                    id="image-ship2"
                    name="aboCollect2"
                    v-model="isConfirm"
                  />
                  <label for="image-ship2" class="sp_chk focus focus">예</label>
                </span>
              </div>
            </div>
          </div>
          <template v-if="purchaseType == 'single'">
            <h2 class="layer_cont_title_s">결제방식</h2>
            <div class="layer_cont_box payment">
              <div class="layer_cont_box">
                <div class="choice-abc">
                  <div class="form_group-element" v-if="!!isOrderPayment">
                    <span class="form_element-radio"><input type="radio" id="payment-auto"  name="paymentCollect" checked="checked" value="auto" v-model="paymentType">
                      <label for="payment-auto" class="payment-auto focus">자동결제(할부 불가, 저장된 결제정보)</label>
                    </span>
                    <span class="form_element-radio"><input type="radio" id="payment-direct" name="paymentCollect" value="direct" v-model="paymentType">
                      <label for="payment-direct" class="payment-direct focus">직접결제(할부 가능, 결제정보 입력)</label>
                    </span>
                  </div>
                  <div class="form_group-element" v-else>
                    <span class="form_element-radio"><input type="radio" id="payment-auto"  name="paymentCollect" checked="checked" value="auto" v-model="paymentType">
                      <label for="payment-auto" class="payment-auto focus">자동결제(할부 불가, 결제정보 저장)</label>
                    </span>
                    <span class="form_element-radio"><input type="radio" id="payment-direct" name="paymentCollect" value="direct" v-model="paymentType">
                      <label for="payment-direct" class="payment-direct focus">직접결제(할부 가능, 결제정보 입력)</label>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <h2 class="layer_cont_title_s">신청 유형을 선택해주세요.</h2>
            <div class="layer_cont_box">
              <div class="choice-abc">
                <div class="form_group-element">
                  <span class="form_element-radio">
                    <input
                      type="radio"
                      id="image-ship"
                      name="aboCollect"
                      checked="checked"
                      value="VCALL"
                      v-model="requestType"
                    />
                    <label for="image-ship" class="image-ship focus"
                      >배달 수령</label
                    >
                  </span>
                  <span class="form_element-radio">
                    <input
                      type="radio"
                      id="visit-ship"
                      name="aboCollect"
                      value="ABC"
                      v-model="requestType"
                    />
                    <label for="visit-ship" class="visit-ship focus"
                      >ABC 수령</label
                    >
                  </span>
                </div>
              </div>
              <a-b-c-section
                v-if="requestType == 'ABC'"
                v-model="abcCd"
                styleClass="abc-select-box"
              />
            </div>
          </template>

          <template v-if="purchaseType == 'recurring'">
            <h2 class="layer_cont_title_s">정기 결제일을 선택해주세요.</h2>
            <div class="layer_cont_box">
              <billing-date-section v-model="billingDate" />
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="align-box size-auto">
      <button
        type="button"
        class="btn-modal_close btn-modal_confirm"
        @click="onDispose"
      >
        취소
      </button>
      <button
        type="button"
        class="btn-modal_close v2"
        :disabled="!canProceed"
        @click="onReorder"
      >
        재구매
      </button>
    </div>
    <modal-unavailable-products
      v-if="soldoutProducts"
      ref="refSoldout"
      :purchase-type="purchaseType"
      :cur-seq="1"
      :re-orderble="reOrderble"
      :re-cal-dose-info="reCalDoseInfo"
      :soldout-products="soldoutProducts"
      @remove-and-proceed="removeAndProceed"
      @cancel-pack="cancelPack"
    />
    <modal-confirm ref="refConfirm" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { log } from "@/utils/common";
import compositionHelpers from "@/utils/helpers/composition";
import productHelpers from "@/utils/helpers/product";
import orderApi from "@/apis/order";
import packApi from "@/apis/pack";
import ABCSection from "@/views/composition/main/step3/ABCSection.vue";
import BillingDateSection from "@/views/composition/main/step3/BillingDateSection.vue";
import Template from "@/views/Template.vue";
import ModalUnavailableProducts from "@/components/modal-popups/ModalUnavailableProducts.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";

export default {
  name: "PopupReorderRequest",
  components: {
    ABCSection,
    BillingDateSection,
    Template,
    ModalUnavailableProducts,
    ModalConfirm,
  },
  props: {
    purchaseType: {
      type: String,
      default: "single",
    },
    reqNo: {
      type: Number,
      default: "single",
    },
    mypackName: {
      type: String,
      default: "single",
    },
    isOrderPayment: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isConfirm: false,
      requestType: "VCALL",
      abcCd: "",
      billingDate: "",
      finalSkus: [],

      applianceDetail: null,

      isSoldout: null,
      soldoutSkus: null,
      soldoutName: null,
      isEndOfSale: null,
      endOfSaleSkus: null,
      endOfSaleName: null,
      reOrderble: null,
      reCalDoseInfo: null,
      soldoutProducts: null,
      paymentType: 'auto'
    };
  },
  computed: {
    ...mapGetters({
      context: "context/context",
      products: "product/products",
    }),
    canProceed() {
      if (this.purchaseType == "single") {
        if (this.requestType == "VCALL") {
          return this.isConfirm;
        } else if (this.requestType == "ABC") {
          return this.isConfirm && !!this.abcCd;
        }
      } else if (this.purchaseType == "recurring") {
        return this.isConfirm && !!this.billingDate;
      }
      return false;
    },
    getAbcCd() {
      if (this.purchaseType == "single") {
        return this.requestType === "VCALL" ? "bundang" : this.abcCd;
      } else if (this.purchaseType == "recurring") {
        return "bundang";
      }
    },
    productsDetails() {
      return this.finalSkus.map((n) => {
        const product = this.products.find((p) => p.item_sku === n.item_sku);
        return {
          item_sku: n.item_sku,
          pockets: n.pockets,
          seq: n.seq,
          item_name: product ? product.item_name : null,
        };
      });
    },
    subscription() {
      return {
        purchaseType: this.purchaseType,
        abcCd: this.getAbcCd,
        requestType:
          this.purchaseType === "single" ? this.requestType : "VCALL",
        billingDate: this.purchaseType === "recurring" ? this.billingDate : "",
        billingStatus: this.purchaseType === "recurring" ? "ACTIVE" : "",
        isConsultation: true,
      };
    },
  },
  methods: {
    onDispose() {
      this.$emit("dispose", "get out!");
    },
    async onReorder() {
      // 주문서 정보 조회
      await this.getApplianceDetail();

      // 재고 체크
      const isUnavailableProducts = await this.isUnavailableProducts();
      if (isUnavailableProducts) {
        await this.$refs.refSoldout.open();
        return;
      }

      let params = {
        reqNo: this.reqNo,
        abcCd: this.getAbcCd,
        cfmKind: this.requestType,
        deliveryAddress: '',
        deliveryMessage: '',
      }
      if (this.requestType === "VCALL") {
        const address = await orderApi.getDeliveryList()
        params.deliveryAddress = address[0].id
        params.deliveryMessage = address[0].message
      }

      await orderApi.updateReqReorderInstallment(params)

      if (this.paymentType == 'auto') {
        await this.onReorderInternal();
      } else {
        const r = await orderApi.getPreOrderInfo(this.reqNo, this.paymentType);
        log("reqNo :::::::::::::::::", this.reqNo);
        log("r :::: ", r);
        if (r.msg) {
          await this.$refs.refAlert.openWithMessage(
            "월 주문 가능 횟수를 초과했습니다."
          );
          return;
        }

        // 주문 불가 제품이 존재하는 경우
        if (r.isSoldout || r.isEndOfSale) {
          // await this.init(r.orderlist);
          await this.checkSoldoutProducts(r);
          return;
        }

        if (r.error) {
          console.log(r);
          return;
        }

        // reset terms
        this.$store.commit("terms/reset");
        
        const amwayPayMethods = await orderApi.getAmwayPayMethods();
        this.$router.push({
          name: "order",
          params: {
            orderInfo: r,
            amwayPayMethods: amwayPayMethods,
            purchaseType: "single"
          },
        });
      }
    },
    async onReorderInternal() {
      await compositionHelpers.doReorderFromMypack(
        this.$store,
        this.applianceDetail,
        this.subscription,
        this.finalSkus,
        this.reqNo,
      );

      // 3. 페이지 이동
      this.$router.push({
        name: "composition-payment",
      });
      this.onDispose();
    },
    async getApplianceDetail() {
      const r = await packApi.getApplianceDetail(this.reqNo, true);
      if (r.error) {
        return false;
      }
      const take_days = r.order_info[0].take_days;
      this.finalSkus = r.order_detail_list.map((n) => ({
        days: take_days,
        item_sku: n.item_sku,
        pockets: n.dose,
        seq: n.dose_list,
      }));
      this.applianceDetail = r;
    },
    async isUnavailableProducts() {
      const r = await orderApi.checkSoldOut(
        "C",
        this.productsDetails,
        this.getAbcCd
      );
      if (r.error) {
        console.error(r.error);
        return;
      }
      log("######### checkSoldOut results #########", r);

      const {
        isSoldout,
        soldoutSkus,
        soldoutName,
        isEndOfSale,
        endOfSaleSkus,
        endOfSaleName,
        reOrderble,
        reCalDoseInfo,
      } = r;

      if (isSoldout || isEndOfSale) {
        this.isSoldout = isSoldout;
        this.soldoutSkus = soldoutSkus;
        this.soldoutName = soldoutName;
        this.isEndOfSale = isEndOfSale;
        this.endOfSaleSkus = endOfSaleSkus;
        this.endOfSaleName = endOfSaleName;
        this.reOrderble = reOrderble;
        this.reCalDoseInfo = reCalDoseInfo;
        this.soldoutProducts = productHelpers.getSoldoutProducts(
          this.products,
          this.productsDetails,
          this.soldoutSkus,
          this.endOfSaleSkus
        );
        return true;
      }
      return false;
    },
    async removeAndProceed() {
      console.log("call removeAndProceed");
      try {
        await this.$refs.refConfirm.openWithMessage(
          "단종 또는 일시품절 등의 제품을 제외하고 마이팩을 주문하시겠습니까?"
        );

        this.finalSkus = this.finalSkus.filter(
          (n) =>
            ![...this.soldoutSkus, ...this.endOfSaleSkus].includes(n.item_sku)
        );

        this.$refs.refSoldout.onDispose();
        await this.onReorderInternal();
      } catch (e) {
        console.log(e);
      }
    },
    async cancelPack() {
      console.log("call cancelPack");
      if (this.isEndOfSale || this.isSoldout) {
        await this.$refs.refConfirm
          .openWithMessage(
            "단종 또는 일시품절 등의 제품으로 인해 마이팩 구매를 취소하시겠습니까?"
          )
          .then(() => {
            this.$refs.refSoldout.onDispose();
            this.onDispose();
          })
          .catch(() => {});
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal-popups/PopupReorderRequest.vue